var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.1075C8.4825 17.1075 7.995 16.845 7.65 16.3875L6.525 14.8875C6.5025 14.8575 6.4125 14.82 6.375 14.8125H6C2.8725 14.8125 0.9375 13.965 0.9375 9.75V6C0.9375 2.685 2.685 0.9375 6 0.9375H12C15.315 0.9375 17.0625 2.685 17.0625 6V9.75C17.0625 13.065 15.315 14.8125 12 14.8125H11.625C11.565 14.8125 11.5125 14.8425 11.475 14.8875L10.35 16.3875C10.005 16.845 9.5175 17.1075 9 17.1075ZM6 2.0625C3.315 2.0625 2.0625 3.315 2.0625 6V9.75C2.0625 13.14 3.225 13.6875 6 13.6875H6.375C6.7575 13.6875 7.1925 13.905 7.425 14.2125L8.55 15.7125C8.8125 16.0575 9.1875 16.0575 9.45 15.7125L10.575 14.2125C10.8225 13.8825 11.2125 13.6875 11.625 13.6875H12C14.685 13.6875 15.9375 12.435 15.9375 9.75V6C15.9375 3.315 14.685 2.0625 12 2.0625H6Z",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6.5625H5.25C4.9425 6.5625 4.6875 6.3075 4.6875 6C4.6875 5.6925 4.9425 5.4375 5.25 5.4375H12.75C13.0575 5.4375 13.3125 5.6925 13.3125 6C13.3125 6.3075 13.0575 6.5625 12.75 6.5625Z",
    fill: "#737373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 10.3125H5.25C4.9425 10.3125 4.6875 10.0575 4.6875 9.75C4.6875 9.4425 4.9425 9.1875 5.25 9.1875H9.75C10.0575 9.1875 10.3125 9.4425 10.3125 9.75C10.3125 10.0575 10.0575 10.3125 9.75 10.3125Z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageText);
export default __webpack_public_path__ + "static/media/message-text.cece05e5fe8be94fd355f8e23000af2c.svg";
export { ForwardRef as ReactComponent };